var _a;
import { createElement, memo, useEffect, useMemo, useState, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import Button from '@hfe/max-button';
import ScrollView from '@hfe/max-scrollview';
import LinearGradient from '@hfe/max-linear-gradient';
import { rpx2px } from '@hfe/max-universal-unit-tool';
import TopView from '@max/leez-top-view';
const isMRN = false;
import './index.scss';
// import { BID } from '../../common/lx';
import { getSafeAreaMarginBottom } from "@max/meituan-uni-screenInfo";
import BottomSliderModal from '../bottom-slider-modal';
import CloseBtn from '../close-btn';
import ExpireTimeDisplay from '../expire-time-display';
import { RewardType, BizLine, AmountType, PrizeStatus, BizLineDesc } from '@/types';
import { MTfinStyle, convertCentsToYuan2, MTNewDigitalDisplayStyle } from '@/utils/common';
const PRIZE_TAB = [{
        label: '境内酒店',
        key: 'hotel',
        values: [BizLine.Hotel
            // BizLine.HomeStay
        ]
    }, {
        label: '民宿',
        key: 'homeStay',
        values: [BizLine.HomeStay]
    }, {
        label: '景点',
        key: 'ticket',
        values: [BizLine.Ticket]
    }, {
        label: '火车票',
        key: 'train',
        values: [BizLine.Train]
    },
    // { label: '机票', key: 'air', values: [BizLine.Air]  },
    {
        label: '度假',
        key: 'vacation',
        values: [BizLine.Vacation]
    }];
const TAB_LIST = [{
        label: '全部',
        key: 'all',
        values: []
    }, ...PRIZE_TAB];
let safeBottomHeight = (_a = getSafeAreaMarginBottom()) !== null && _a !== void 0 ? _a : 0; //获取底部安全高度
safeBottomHeight = Math.max(safeBottomHeight, 20);
const CouponUsageRecord = (props) => {
    const { modalVisible, onCloseModal, dataList, goToUse } = props;
    const [activeIndex, setActiveIndex] = useState(0);
    // 初始化所有tab的空数据结构
    const initializeEmptyData = () => {
        const emptyData = {};
        TAB_LIST.forEach(tab => {
            emptyData[tab.key] = [];
        });
        return emptyData;
    };
    const [allCouponData, setAllCouponData] = useState(initializeEmptyData());
    const scrollViewRef = useRef(null);
    // 计算当前显示的优惠券列表
    const displayedCouponList = useMemo(() => {
        if (!Array.isArray(TAB_LIST) || TAB_LIST.length === 0 || activeIndex >= TAB_LIST.length) {
            return [];
        }
        const currentTab = TAB_LIST[activeIndex];
        if (!currentTab) {
            return [];
        }
        const key = currentTab.key;
        const data = allCouponData === null || allCouponData === void 0 ? void 0 : allCouponData[key];
        return Array.isArray(data) ? data : [];
    }, [allCouponData, activeIndex]);
    const processDataBeforeCategorize = (data) => {
        const renderList = [];
        data.forEach(item => {
            if (!item) {
                return; // 跳过 null/undefined 的项
            }
            // 过滤掉已过期的奖品
            if (item.prizeStatus === PrizeStatus.EXPIRED) {
                return;
            }
            // 如果是奖励包且有子奖励
            if (item.rewardType === RewardType.Package && Array.isArray(item.userSubPrizeInfoList) && item.userSubPrizeInfoList.length > 0) {
                // 将userSubPrizeInfoList的元素提到渲染list中（需要过滤其中已过期的子奖励）
                const validSubPrizes = item.userSubPrizeInfoList.filter(subItem => (subItem === null || subItem === void 0 ? void 0 : subItem.prizeStatus) !== PrizeStatus.EXPIRED);
                renderList.push(...validSubPrizes);
            }
            else {
                // 非奖励包的元素直接放到渲染list中
                renderList.push(item);
            }
        });
        return renderList;
    };
    const categorizeDataByTab = (data) => {
        const categorizedData = {};
        // 初始化所有tab的数据为空数组
        TAB_LIST.forEach(tab => {
            const tabKey = tab.key;
            categorizedData[tabKey] = [];
        });
        // 将数据按照类型分类到对应的tab中
        data.forEach(item => {
            if (!item) {
                return; // 跳过 null/undefined 的项
            }
            categorizedData.all.push(item);
            const { bizLine } = item;
            // bizLine 可能为 undefined，添加防御检查
            if (bizLine !== undefined && bizLine !== null) {
                const targetTab = PRIZE_TAB.find(tab => tab.values.includes(bizLine));
                if (targetTab) {
                    categorizedData[targetTab.key].push(item);
                }
            }
        });
        return categorizedData;
    };
    useEffect(() => {
        if (modalVisible && Array.isArray(dataList) && dataList.length > 0) {
            // 处理数据：展开奖励包中的子奖励
            const processedData = processDataBeforeCategorize(dataList);
            // 对处理后的数据进行分类
            const categorizedData = categorizeDataByTab(processedData);
            setAllCouponData(categorizedData);
        }
        else if (modalVisible && (!Array.isArray(dataList) || dataList.length === 0)) {
            // 如果没有数据，重置为空状态
            const emptyData = {};
            TAB_LIST.forEach(tab => {
                emptyData[tab.key] = [];
            });
            setAllCouponData(emptyData);
        }
    }, [modalVisible, dataList]);
    useEffect(() => { }, [activeIndex]);
    const renderContent = () => <LImage className="coupon-usage-record__container" source={{
        uri: 'https://p0.meituan.net/ingee/09f2bd12f08f78c0c39d49a9d03918fa10241.png'
    }} borderRadius={0} style={{
        width: '750rpx',
        height: '976rpx'
    }}>
      
      <View className="tab-container">
        {TAB_LIST.map((item, index) => {
        const tabData = allCouponData === null || allCouponData === void 0 ? void 0 : allCouponData[item.key];
        const tabCouponCount = Array.isArray(tabData) ? tabData.length : 0;
        const isActiveTab = activeIndex === index;
        return <Button key={item.key} className='tab-item' onPress={() => {
            setActiveIndex(index);
        }}>
                <Text className="tab-text" style={{
            color: isActiveTab ? '#111111' : '#2E1F00',
            fontSize: isActiveTab ? '28rpx' : '26rpx',
            opacity: isActiveTab ? 1 : 0.7
        }}>{item.label}<Text x-if={item.key === 'all'} className="tab-text-append" style={MTfinStyle}>{tabCouponCount}</Text></Text>

                <LinearGradient className="tab-line" colors={['#FFE028', '#FFE028']} style={{
            opacity: isActiveTab ? 1 : 0
        }} start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 1
        }}/>
              </Button>;
    })}
      </View>
      <ScrollView className="coupon-usage-record__scroll-view" showsVerticalScrollIndicator={false} ref={scrollViewRef}>
        <View x-if={(displayedCouponList === null || displayedCouponList === void 0 ? void 0 : displayedCouponList.length) >= 1} className="coupon-usage-record__content" style={{
        paddingBottom: safeBottomHeight
    }}>
          {displayedCouponList === null || displayedCouponList === void 0 ? void 0 : displayedCouponList.map(couponItem => {
        let finalAmount = couponItem.amount;
        if (couponItem.amountType === AmountType.FullReduction) {
            const res = convertCentsToYuan2(Number(couponItem.amount));
            finalAmount = res.integerPart;
        }
        if (couponItem.amountType === AmountType.Discount) {
            const discountValue = Number(couponItem.amount) / 10;
            // 判断是否为整数，如果是整数则不显示小数位，否则显示1位小数
            finalAmount = Number.isInteger(discountValue) ? discountValue.toString() : discountValue.toFixed(1);
        }
        const isInvalid = couponItem.prizeStatus === PrizeStatus.USED || couponItem.prizeStatus === PrizeStatus.EXPIRED;
        const isCanUse = couponItem.prizeStatus === PrizeStatus.DRAWN || couponItem.prizeStatus === PrizeStatus.NOT_USED;
        // const prizeDesc = couponItem.prizeDesc;
        const bizLine = couponItem.bizLine;
        const requireAmount = (couponItem === null || couponItem === void 0 ? void 0 : couponItem.requireAmount) ? `${(couponItem === null || couponItem === void 0 ? void 0 : couponItem.requireAmount.indexOf('满')) > -1 ? '' : '满'}${couponItem === null || couponItem === void 0 ? void 0 : couponItem.requireAmount}${(couponItem === null || couponItem === void 0 ? void 0 : couponItem.requireAmount.indexOf('可用')) > -1 ? '' : '可用'}` : '无门槛';
        return <LImage className="coupon-usage-item-wrap" source={{
            uri: 'https://p0.meituan.net/ingee/96c248ac30c3b424eae133c29588a9034581.png'
        }} borderRadius={0}>
                <View className="coupon-usage-item-left" style={{
            opacity: isInvalid ? 0.5 : 1
        }}>
                  <View className="coupon-usage-item-price">
                    <Text x-if={couponItem.amountType === AmountType.FullReduction} className="coupon-usage-amount-wrap">
                      <Text className="coupon-usage-item-price-symbol">¥</Text>
                      <Text className="coupon-usage-item-price-value" style={MTNewDigitalDisplayStyle}>{finalAmount}</Text>
                    </Text>
                    <Text x-if={couponItem.amountType === AmountType.Discount} className="coupon-usage-amount-wrap">
                      <Text className="coupon-usage-item-price-value" style={MTNewDigitalDisplayStyle}>{finalAmount}</Text>
                      <Text className="coupon-usage-item-price-symbol">折</Text>
                    </Text>
                  </View>
                  <Text className="coupon-usage-item-condition" numberOfLines={1}>{requireAmount}</Text>
                </View>
                <View className="coupon-usage-item-mid" style={{
            opacity: isInvalid ? 0.5 : 1
        }}>
                  <Text className="coupon-usage-item-title" numberOfLines={1}>{couponItem.prizeName}</Text>
                  <ExpireTimeDisplay prize={couponItem}/>

                  
                  <Text x-if={bizLine} className="coupon-usage-item-limit" numberOfLines={1}>美团{BizLineDesc[bizLine]}商品可用</Text>
                </View>
                <View className="coupon-usage-item-right">
                  <Button x-if={isCanUse} className="coupon-usage-item-status-btn-inner" onPress={() => goToUse && goToUse(couponItem)}>
                    <Text className="coupon-usage-item-status-text">去使用</Text>
                  </Button>

                  <Text x-if={isInvalid} className="coupon-usage-item-status-text">
                    {couponItem.prizeStatus === PrizeStatus.USED ? '已使用' : '已过期'}
                  </Text>
                </View>
              </LImage>;
    })}
        </View>

        <View x-if={!Array.isArray(displayedCouponList) || (displayedCouponList === null || displayedCouponList === void 0 ? void 0 : displayedCouponList.length) < 1} className="coupon-usage-record__empty-content">
          <LImage source={{
        uri: 'https://p0.meituan.net/ingee/f492314a58e6fe5554507859f41470d250411.png'
    }} width={rpx2px(300)} height={rpx2px(326)}/>
          <Text className="coupon-usage-record__empty-text">暂无奖励记录～</Text>
        </View>

      </ScrollView>
    </LImage>;
    return <TopView>
      <BottomSliderModal heightInRpx={'962rpx'} visible={modalVisible} onClose={onCloseModal} topBanner={<View className="coupon-list-title">
            <CloseBtn style={{
        position: 'absolute',
        right: '25rpx',
        top: '-24rpx'
    }} onClose={props.onCloseModal}/>
          </View>}>
        {renderContent()}
      </BottomSliderModal>
    </TopView>;
};
export default memo(CouponUsageRecord);
